import styled from "styled-components";
import { MEDIA_Q } from "../../config/constants/css";

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  gap: 20px;
  align-items: center;
`;

export const StyledMainContainer = styled.div`
  width: ${(p) => (p.$width ? `min(${p.$width}, 100vw) !important` : "95vw")};
  ${MEDIA_Q.SM} {
    width: 540px;
  }
  ${MEDIA_Q.MD} {
    width: 720px;
  }
  ${MEDIA_Q.LG} {
    width: 960px;
  }
  ${MEDIA_Q.XL} {
    width: 1140px;
  }
  ${MEDIA_Q.XXL} {
    width: 1320px;
  }
`;

export const StyledModalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100vw;
  max-height: 100vh;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  &:focus-visible {
    outline: none !important;
  }
`;
